<!-- 零售- 赠品兑换登记、客情赠品登记 -->
<template>
  <div class="cus-modal" v-loading="loading">
    <div class="container">
      <div v-for="(tableKey, index) in Object.keys(skuTable).filter(i => i != 'tableConfigAdd')" :key="index" class="sku">
        <Tag 
          color="blue"
          v-for="(skuKey, idx) in Object.keys(skuTable[tableKey].sku).filter(i => ['skuCode', 'skuName'].includes(i))" 
          :key="`sku_${idx}`"
        >
          {{ skuTable[tableKey].sku[skuKey] }}
        </Tag>
        <Table
          :class="['jordan-table', tableKey]"
          :ref="tableKey"
          :columns="skuTable[tableKey].columns"
          :data="skuTable[tableKey].data"
          :colRowMethod="(row, column, rowIndex, columnIndex) => colRowMethod(row, column, rowIndex, columnIndex, skuTable[tableKey].rowspan)"
          multiple
          border
          @on-select="(v) => onSelect(v, tableKey)"
          @on-select-cancel="(v) => onSelectCancel(v, tableKey)"
          @on-select-all="(v) => onSelectAll(v, tableKey)"
          @on-select-all-cancel="(v) => onSelectAllCancel(v, tableKey)"
        />
      </div>
      <div class="add-gift" v-if="skuTable.tableConfigAdd">
        <Table
          class="jordan-table"
          ref="tableConfigAdd"
          :columns="skuTable.tableConfigAdd.columns"
          :data="skuTable.tableConfigAdd.data"
          multiple
          border
          @on-select="(v) => onSelect(v, 'tableConfigAdd')"
          @on-select-cancel="(v) => onSelectCancel(v, 'tableConfigAdd')"
          @on-select-all="(v) => onSelectAll(v, 'tableConfigAdd')"
          @on-select-all-cancel="(v) => onSelectAllCancel(v, 'tableConfigAdd')"
        />
        <div class="wrap">
          <OmsForm :form-config="formConfig" />
          <Button type="primary" @click="addGift">{{t('添加')}}</Button>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="checkAll">
        <Checkbox v-model="checkAll" @on-change="onCheckAll" :disabled="checkAllDisabled">{{t('全选')}}</Checkbox>
        <span style="color: red;">* {{t('赠品库存数量为0，不可勾选')}}</span>
      </div>
      <OmsButton :btn-config="btnConfig" />
    </div>
  </div>
</template>

<script>
import mergeCellsMixin from '@/assets/js/mixins/mergeCells'

export default {
  name: 'giftExchange',
  mixins: [mergeCellsMixin],
  props: {
    componentData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      checkAll: false,
      skuTable: {},
      reasonList: [],
      formConfig: {
        formValue: {
          giftSkuId: '',
          qty: '',
          reasonId: '',
          reasonCode: '',
          reasonName: '',
          deadline: '',
        },
        formData: [
          {
            style: 'dropSelect',
            width: '6',
            itemdata: {
              filterConds: [
                { fixcolumn: 'IS_GIFT', refobjid: 'Y' },
              ],
              colid: 174272, // 字段id
              colname: 'giftSkuId', // 当前字段的名称 用来显示的
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              name: t('赠品信息'),
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.giftSkuId = e.pid
            },
          },
          {
            style: 'input',
            label: t('赠品数量'),
            regx: /^[1-9]\d*$/,
            value: 'qty',
            width: '6',
            placeholder: t('请完成输入后回车'),
            inputenter: (val) => this.addGift()
          },
          {
            style: 'select',
            label: t('赠品兑换原因'),
            value: 'reasonId',
            width: '6',
            options: [],
            selectChange: (val) => {
              console.log(val)
              const reason = this.reasonList.find(i => val && i.value == val.value)
              this.formConfig.formValue.reasonId = reason ? reason.value : ''
              this.formConfig.formValue.reasonCode = reason ? reason.code : ''
              this.formConfig.formValue.reasonName = reason ? reason.label : ''
            },
          },
          {
            style: 'date',
            type: 'date', // 日期组件类型,默认为data  (daterange)为双日期区间选择
            value: 'deadline',
            label: t('兑换截止日期'),
            width: '6',
            format: 'yyyy-MM-dd',
            options: {
              disabledDate (date) {
                return date && date.valueOf() < Date.now() - 86400000;
              }
            }
          },
        ],
        ruleValidate: {
          giftSkuId: [{ required: true, message: ' ', trigger: 'blur' }],
          qty: [{ required: true, message: ' ', trigger: 'blur' }],
          reasonId: [{ required: true, message: ' ', trigger: 'blur' }],
          deadline: [{ required: true, message: ' ', trigger: 'blur' }],
        },
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.save();
            },
          },
        ],
      },
    };
  },
  computed: {
    // 全选是否禁用
    checkAllDisabled() {
      let flag = true
      for (let key in this.skuTable) {
        if (this.skuTable[key].data.length) {
          this.skuTable[key].data.some(i => i.stockQty > 0) && (flag = false)
          break
        }
      }
      return flag
    }
  },
  async mounted() {
    console.log(this.componentData)
    await this.getReasonList()
    if (this.componentData.webname == 'gift_exchange_register') {
      this.componentData.sku.forEach((i, index) => {
        this.getTableConfig(index, i)
      });
    }
    this.getTableConfig('Add')
  },
  methods: {
    save() {
      let data = []
      let hasEmpty = false
      for (let key in this.skuTable) {
        if (this.skuTable[key].selectionData.length) {
          const skuArr = this.skuTable[key].selectionData.map(i => i.giftSkuId)
          let sku = {
            giftInfos: this.skuTable[key].data.filter(i => skuArr.includes(i.giftSkuId)).map(i => {
              i.qty = i.curQty
              return i
            })
          }
          if (this.skuTable[key].sku) {
            sku = { ...sku, ...this.skuTable[key].sku }
          } else {
            sku.orderId = this.componentData.row.ID
          }
          data.push(sku)
          for (let gift of sku.giftInfos) {
            if (gift.deadline == '') {
              $fcWarn({ content: t('请维护【{}】兑换截止日期', gift.giftSkuCode) })
              hasEmpty = true
              break;
            }
            if (gift.reasonId == '' || gift.reasonCode == '' || gift.reasonName == '' || !this.reasonList.some(i => i.value == gift.reasonId)) {
              $fcWarn({ content: t('请维护【{}】兑换原因', gift.giftSkuCode) })
              hasEmpty = true
              break;
            }
          }
          console.log(sku)
        }
      }
      if (!data.length) return $fcWarn({ content: t('请勾选赠品数据') })
      if (hasEmpty) return
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/giftExchange/save', data).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.getData();
          this.$parent.$parent.$parent.selection = [];
        }
      })
    },
    async addGift() {
      const form = _.cloneDeep(this.formConfig.formValue)
      let flag = false
      for (let item of this.formConfig.formData) {
        if (form[item.colname] == '') {
          flag = true
          $fcWarn({ content: t('请完善赠品信息') })
          break
        }
      }
      if (flag) return
      const params = {
        id: this.componentData.row.ID,
        skuId: form.giftSkuId
      }
      const sku = await this.getSku(params)
      if (!sku) return
      sku.stockQty == 0 && (sku._disabled = true)
      this.$set(this.skuTable.tableConfigAdd, 'data', [...this.skuTable.tableConfigAdd.data, {
        ...sku,
        ...form,
        deadline: form.deadline ? $utils.Format(new Date(form.deadline), 'yyyy-MM-dd') : '',
        curQty: form.qty > sku.stockQty ? sku.stockQty : form.qty,
        _prohibitClickToSelect: true, // 禁止单击选中行
      }])
      $utils.clear(this.formConfig)
    },
    // 查询SKU信息
    async getSku(params) {
      const searchParam = new URLSearchParams();
      for (let key in params) {
        searchParam.append(key, params[key]);
      }
      return new Promise(async (resolve) => {
        const res = await this.service.common.publicUrlParams('/api/cs/oc/oms/v1/gift/sku/select', searchParam)
        if (res.data.code == 0 && res.data.data) {
          resolve(res.data.data)
        }
      })
    },
    // 查询兑换原因
    async getReasonList() {
      const res = await this.service.common.publicUrlParams('/api/cs/oc/oms/v1/reason/select')
      if (res.data.code == 0) {
        this.reasonList = res.data.data.map(i => {
          return { label: i.reasonName, value: i.reasonId, code: i.reasonCode }
        })
        $utils.queryForm(this.formConfig, 'reasonId').options = this.reasonList
      }
    },
    getTableConfig(key, sku) {
      const tableKey = `tableConfig${key}`
      let eqVal = {}
      key != 'Add' && (eqVal = this.mergeRow(sku.giftInfos)) // 存储合并单元格数据
      
      const columns = [
        {
          type: 'selection',
          align: 'center',
          fixed: 'left',
          width: 30,
        },
        {
          key: 'activityName',
          title: t('活动名称'),
          render: (h, params) => {
            if (key == 'Add' || key != 'Add' && eqVal.get(params.row.activityName).length == 1) {
              return h('div', {
                style: {
                  textAlign: 'center'
                }
              }, params.row.activityName)
            }
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
              h('span', {}, params.row.activityName),
              h('div', {}, [
                h('Checkbox', {
                  props: {
                    value: params.row._checkAll,
                  },
                  on: {
                    'on-change': (val) => {
                      // console.log(val)
                      params.row._checkAll = val
                      params.row._checked = val
                      this.skuTable[tableKey].data[params.index] = params.row
                      const eqVal = this.mergeRow(this.skuTable[tableKey].data)
                      document.querySelectorAll(`.${tableKey} .ark-table-fixed-body tbody tr`).forEach((element, nodeIndex) => {
                        if (eqVal.get(params.row.activityName).find(i => i.index == nodeIndex) 
                          && (val ? !element.querySelector('input:checked') : element.querySelector('input:checked'))) {
                          // console.log(eqVal.get(params.row.activityName), nodeIndex, element)
                          element.querySelector('td label').click()
                        }
                      })
                    },
                  },
                }),
                h('span', {}, t('全选'))
              ])
            ])
          }
        },
        {
          key: 'giftType',
          title: t('类型'),
          render: (h, params) => {
            return h('span', {}, params.row.giftType == 1 ? t('赠品兑换') : t('客情兑换'))
          }
        },
        {
          key: 'giftSkuCode',
          title: t('赠品SKU'),
        },
        {
          key: 'giftSkuName',
          title: t('赠品名称')
        },
        {
          key: 'curQty',
          title: t('赠品数量'),
          width: 90,
          render: (h, params) => {
            return h('Input', {
              props: {
                value: Number(params.row.curQty),
                min: 0,
                max: params.row.qty,
                regx: /^[1-9]\d*$/
              },
              on: {
                'on-blur': () => {
                  this.$set(this.skuTable[tableKey].data, params.index, params.row)
                },
                'on-change': (e) => {
                  const cb = (row, val, tableKey) => {
                    const { qty, stockQty } = row
                    if (tableKey == 'tableConfigAdd') {
                      if (val > stockQty) {
                        this.$Message.warning(t('赠品数量不可大于赠品库存'))
                        return stockQty
                      }
                    } else {
                      if (val > qty) {
                        this.$Message.warning(t('赠品数量不可大于活动赠品数量'))
                        return qty
                      }
                    }
                    return val
                  }
                  let qty = cb(params.row, Number(e.target.value), tableKey)
                  params.row.curQty = qty
                  this.skuTable[tableKey].data[params.index] = params.row;
                }
              }
            })
          }
        },
        {
          key: 'qty',
          title: t('活动赠品数量'),
        },
        {
          key: 'stockQty',
          title: t('赠品库存'),
        },
        {
          key: 'deadline',
          title: t('兑换截止日期'),
          width: 170,
          render: (h, params) => {
            return h('DatePicker', {
              props: {
                value: params.row.deadline,
                transfer: true,
                type: 'date',
                format: 'yyyy-MM-dd',
                options: {
                  disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                  }
                }
              },
              nativeOn: {
                click: (e) => {
                  e.stopPropagation();
                  e.preventDefault();// 阻止默认事件
                }
              },
              on: {
                'on-change': (val, e) => {
                  console.log(val)
                  this.skuTable[tableKey].data[params.index].deadline = val ? $utils.Format(new Date(val), 'yyyy-MM-dd') : ''
                }
              }
            })
          }
        },
        {
          key: 'reasonId',
          title: t('兑换原因'),
          width: 150,
          render: (h, params) => {
            const options = this.reasonList.map(item => h('Option', { props: item }));
            return h('Select', {
              props: {
                transfer: true,
                clearable: false,
                value: params.row.reasonId,
              },
              nativeOn: {
                click: (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }
              },
              on: {
                'on-change': (val, e) => {
                  console.log(val)
                  const reason = this.reasonList.find(i => i.value == val)
                  this.skuTable[tableKey].data[params.index].reasonId = reason.value
                  this.skuTable[tableKey].data[params.index].reasonCode = reason.code
                  this.skuTable[tableKey].data[params.index].reasonName = reason.label
                }
              }
            }, options)
          }
        },
        {
          key: 'remarks',
          title: t('备注'),
          width: 200,
          render: (h, params) => {
            return  h('div', {
                style: {
                  padding: '6px 0',
                }
              }, [
              h('Input', {
                props: {
                  type: 'textarea',
                  rows: 2,
                  value: params.row.remarks,
                },
                on: {
                  'on-change': e => {
                    params.row.remarks = e.target.value
                    this.skuTable[tableKey].data[params.index] = params.row
                  }
                }
              })
            ])
          }
        }
      ]

      const tableConfig = {
        indexColumn: true,
        isShowSelection: true,
        pageShow: false, // 控制分页是否显示
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        columns,
        data: [],
        selectionData: [],
      }
      
      if (key == 'Add') { // 添加赠品
        tableConfig.columns = tableConfig.columns.filter(i => i.key != 'qty')
        tableConfig.columns.push({
          key: 'IS_DELETE',
          title: t('操作'),
          render: (h, params) => h('a',
            {
              on: {
                click: () => {
                  this.skuTable[tableKey].data.splice(params.index, 1);
                }
              }
            },
            t('删除')
          )
        })
        this.$set(this.skuTable, tableKey, tableConfig)
      } else { // 商品赠品信息
        let rowspan = []
        const data = sku.giftInfos.map((i, index) => {
          i._checkAll = false
          i.curQty = i.qty
          i._disabled = i.stockQty == 0
          i._prohibitClickToSelect = true

          // 行合并
          if (index == 0) {
            rowspan.push(1)
          } else {
            if (i.activityName == sku.giftInfos[index-1].activityName) {
              rowspan.push(0)
            } else {
              rowspan.push(1)
            }
          }
          return i
        })

        const skuInfo = _.cloneDeep(sku)
        delete skuInfo.giftInfos
        this.$set(this.skuTable, tableKey, {
          ...tableConfig,
          data,
          rowspan,
          sku: skuInfo
        })
      }
    },
    // 行合并 - 记录相同值的行
    mergeRow(gifts, colname = 'activityName') {
      const eqVal = new Map()
      gifts.forEach((row, index) => {
        const val = row[colname]
        if (eqVal.has(val)) {
          eqVal.set(val, [...eqVal.get(val), { index, id: row.giftSkuId }])
        } else {
          eqVal.set(val, [{ index, id: row.giftSkuId }])
        }
      })
      // console.log(eqVal)
      return eqVal
    },
    // 行合并
    colRowMethod(row, column, rowIndex, columnIndex, rowspan) {
      if (columnIndex == 1) {
        return {
          rowspan,
          colspan: 1
        }
      }
    },
    // 全选-所有表格
    onCheckAll() {
      const val = this.checkAll
      for (let key in this.$refs) {
        if (key == 'tableConfigAdd') {
          this.$refs[key].selectAll(val)
        } else {
          this.$refs[key][0].selectAll(val)
        }
      }
    },
    // 合并单元格的全选是否勾选
    setCheckAll(selection, tableKey) {
      const eqVal = this.mergeRow(this.skuTable[tableKey].data)
      const keys = [...eqVal.keys()]
      keys.forEach(key => {
        const arr = eqVal.get(key)
        const checkedGifts = selection.filter(i => i.activityName == key)
        // 当前勾选的同活动名称的行数，是否等于合并行数
        const isCheckAll = checkedGifts.length == arr.length
        this.skuTable[tableKey].data.find(i => i.giftSkuId == arr[0].id)._checkAll = isCheckAll
      })
    },
    // 同步数据data和selectionData
    tableData(selection, tableKey) {
      if (tableKey != 'tableConfigAdd') {
        this.setCheckAll(selection, tableKey)
      }
      const skuArr = selection.map(i => i.giftSkuId)
      this.skuTable[tableKey].data.forEach(i => i._checked = false)
      const selectionData = this.skuTable[tableKey].data.filter(i => skuArr.includes(i.giftSkuId)).map(i => {
        if (i.stockQty != 0) {
          i._checked = true
        }
        return i
      })
      return selectionData
    },
    // 选中某一项时触发
    onSelect(selection, tableKey) {
      const selectionData = this.tableData(selection, tableKey)
      this.skuTable[tableKey].selectionData = selectionData;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection, tableKey) {
      const selectionData = this.tableData(selection, tableKey)
      this.skuTable[tableKey].selectionData = selectionData;
      this.checkAll = false
    },
    // 点击全选时触发
    onSelectAll(selection, tableKey) {
      const selectionData = this.tableData(selection, tableKey)
      this.skuTable[tableKey].selectionData = selectionData;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection, tableKey) {
      this.skuTable[tableKey].data.forEach(i => {
        i._checked = false
        i._checkAll = false
      })
      this.skuTable[tableKey].selectionData = [];
      this.checkAll = false
    },
  }
};
</script>
<style lang="less" scoped>
.cus-modal {
  /deep/ textarea {
    font-size: 12px !important;
  }
  /deep/ .ark-date-picker i.ark-icon-ios-calendar-outline {
    line-height: 26px !important;
  }
  /deep/ .ark-table td {
    .ark-input {
      height: 26px;
    }
  }
  .ark-tag {
    line-height: 27px;
    height: 29px;
    margin-bottom: 5px;
    margin-right: 8px;
    cursor: default;
  }
  .container {
    max-height: 80vh;
    overflow: auto;
  }
  .sku, .add-gift {
    border: 1px solid #eee;
    box-shadow: 0px 0px 4px #dad6d6;
    border-radius: 5px;
  }
  .sku {
    margin-bottom: 12px;
    padding: 12px;
  }
  .add-gift {
    padding: 12px;
    margin-bottom: 12px;
    /deep/ .cusForm-content, .business-form-main {
      padding-bottom: 0;
    }
    .business-form-main {
      margin-top: 10px;
    }
    .wrap {
      display: flex;
      align-items: center;
      button {
        margin-top: 10px;
        margin-bottom: 0;
      }
    }
  }
  /deep/ .ark-date-picker {
    i.ark-icon-ios-calendar-outline {
      line-height: 1;
    }
  }
  .modal-footer {
    padding-top: 12px;
    .checkAll {
      position: absolute;
    }
  }
}
</style>